import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import Button from './Button';
import { SvgIcon } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import { isDarkMode } from '../../utils/helpers';
import colors from '../../theme/colors';
import breakpoints from '../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const StyledProfileEditButtonV2 = styled(Button)(() => ({
  fontSize: '14px !important',
  color: '#2B8FD7 !important',
  fontWeight: '600 !important',
  borderRadius: '6px !important',
  border: '1px solid #2B8FD7 !important',
  display: 'flex !important',
  alignContent: 'center !important',
  alignItems: 'center !important',
  padding: '12px !important',
  height: '32px !important',
  cursor: 'pointer !important',
  lineHeight: '17px !important',
  ':hover': {
    backgroundColor: isDarkMode() ? `${colors.blue[600]} !important` : `${colors.blue[500]} !important`,
    color: isDarkMode() ? `${colors.blue[100]} !important` : '#fff !important',
    border: isDarkMode() ? `${colors.blue[600]} !important` : `${colors.blue[500]} !important`,
    '& svg': {
      color: isDarkMode() ? `${colors.blue[100]} !important` : '#fff !important',
    },
  },
  ':focus': {
    backgroundColor: 'inherit',
    color: colors.blue[500],
    border: 'inherit',
  },
  [breakpoints.down(620.05)]: {
    float: 'unset !important',
    paddingBottom: 0,
    paddingLeft: 2,
    fontSize: 13,
    fontWeight: 600,
    color: '#95C7EB !important',
    paddingTop: 0,
    '& svg': {
      color: '#95C7EB !important',
      marginRight: '2px !important',
      height: '15px !important',
      width: '15px !important',
    },
    ':hover': {
      border: 'solid 1px transparent',
    },
    border: '1px solid transparent !important',
    height: 'auto !important',
    padding: '0 !important',
    width: '60px',
  },
}));

const closeButton = {
  marginRight: 4,
  color: '#2B8FD7',
  cursor: 'pointer',
  height: 16,
  width: 16,
};

interface CancelButtonProps {
  handleClick(): void;
  dataTestId: string;
  customStyle: any;
  id?: string;
}

const ProfileEditButtonV2 = ({ handleClick, dataTestId, customStyle, id }: CancelButtonProps): ReactElement => {
  return (
    <StyledProfileEditButtonV2 data-test-id={dataTestId} onClick={handleClick} customStyle={customStyle} id={id}>
      <SvgIcon component={EditIcon} style={closeButton} />
      Edit
    </StyledProfileEditButtonV2>
  );
};

export default ProfileEditButtonV2;
